<fieldset class="form--fieldset" *ngIf="showAttachments()">
  <legend class="form--fieldset-legend">
    {{ text.attachments }}
  </legend>
  <div id="attachments_fields">
    <op-attachment-list *ngIf="resource.attachments"
                     [resource]="resource">
    </op-attachment-list>
    <op-attachments-upload [resource]="resource"
                        class="hide-when-print"
                        *ngIf="allowUploading">
    </op-attachments-upload>
  </div>
</fieldset>

